import React from 'react';
import { useTranslation } from 'react-i18next';
import Col from 'react-bootstrap/Col';
import FormInput from '../../Form/FormInput';
import { Row } from 'react-bootstrap';
import { IFormError } from '../../../constants/Interfaces';

interface INameInputGroup {
  inputColSizeSm: number;
  inputColSizeMd?: number;
  fieldError?: IFormError;
}

const NameInputGroup: React.FC<INameInputGroup> = ({
  inputColSizeSm,
  inputColSizeMd,
  fieldError,
}) => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col sm={inputColSizeSm} md={inputColSizeMd}>
        <FormInput
          size='sm'
          label={`${t('user_form_label_name')} *`}
          name='name'
          type='text'
          fieldError={fieldError}
        />
      </Col>
      <Col sm={inputColSizeSm} md={inputColSizeMd}>
        <FormInput
          size='sm'
          label={t('user_form_label_lastname')}
          name='lastName'
          type='text'
          fieldError={fieldError}
        />
      </Col>
    </Row>
  );
};

export default NameInputGroup;
